import { ReactNode } from 'react';
import { useTheme } from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import StyledSvg from '@sdk/components/ui/StyledSvg';
import { SvgComponentType } from '@sdk/types';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import {
  RowContainer,
  LabelSection,
  ContentSection,
  LabelText,
} from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/modalRow.styles';

type Props = {
  label: string;
  icon: SvgComponentType;
  children: ReactNode;
  mTop?: number;
};

const ModalRow = ({ label, icon, children, mTop = 10 }: Props) => {
  const theme = useTheme();
  return (
    <RowContainer mTop={mTop}>
      <LabelSection>
        <LabelText bold themeColor={ThemeColorType.gray} uppercase>
          {label}
        </LabelText>

        <Row mLeft={10} mRight={10}>
          <StyledSvg svg={icon} color={theme.colors[ThemeColorType.iconGray]} />
        </Row>
      </LabelSection>
      <ContentSection alignItems="center">{children}</ContentSection>
    </RowContainer>
  );
};

export default ModalRow;
